import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '#/shared/utils';
import {
  dtoToNotificationSetting,
  NotificationSettingDTO,
  notificationSettingToDTO
} from './notification-settings.dto';
import { NotificationSetting } from '#/entities/notification-setting';
import { TUserId } from '#/shared/types';

type NotificationSettingResponse = {
  Items: NotificationSettingDTO[];
};

type UpdateNotificationSettingsRequestBody = {
  UserId: TUserId;
  Items: NotificationSettingDTO[];
};

export const notificationSettingsApi = createApi({
  reducerPath: 'notificationSettingApi',
  baseQuery: createBaseQuery('/v1/notifications/settings', { isMock: false }),
  tagTypes: ['NotificationSettings'],
  endpoints: (builder) => ({
    getNotificationSettings: builder.query<NotificationSetting[], { userId?: TUserId }>({
      query: ({ userId }) => ({
        method: 'GET',
        url: '/',
        params: { userId }
      }),
      transformResponse: (response: NotificationSettingResponse) => {
        return dtoToNotificationSetting(response.Items);
      },
      providesTags: ['NotificationSettings']
    }),
    updateNotificationSettings: builder.mutation<
      NotificationSetting[],
      { userId: TUserId; settings: NotificationSetting[] }
    >({
      query: ({ userId, settings }) => ({
        method: 'POST',
        url: '/',
        body: {
          UserId: userId,
          Items: settings.map(notificationSettingToDTO)
        } as UpdateNotificationSettingsRequestBody
      }),
      invalidatesTags: ['NotificationSettings']
    })
  })
});

export const { useGetNotificationSettingsQuery, useUpdateNotificationSettingsMutation } =
  notificationSettingsApi;
